module.exports = __webpack_public_path__ + "images/d9e8cc7aca633426b44c439b825e0c17975bfd6df5c447e9bf22c133d6e3b672.svg";